import { AfterViewInit, Component, Renderer2, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'nh-scroll-top',
  templateUrl: './scroll-top.component.html',
  styleUrls: ['./scroll-top.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class ScrollTopComponent implements AfterViewInit {
  isButtonVisible: boolean = false;
  scrollProgress: number = 0;
  scrollListener: () => void = () => { };

  constructor(private renderer: Renderer2) {
  }

  ngAfterViewInit() {
    this.scrollListener = this.renderer.listen('window', 'scroll', () => {
      const scrollOffset = window.scrollY || document?.documentElement.scrollTop;
      const documentHeight = document?.documentElement.scrollHeight - window.innerHeight;
      this.scrollProgress = documentHeight > 0 ? (scrollOffset / documentHeight) * 100 : 0;
      this.isButtonVisible = scrollOffset > 50;
    });
  }

  scrollToTop(event: Event) {
    // Remove focus from button so the progress ring returns to blue during scroll animation
    (event.target as HTMLElement).blur();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  ngOnDestroy(): void {
    this.scrollListener();
  }
}
